const paymentMethodsList = {
  /* eslint-disable global-require */
  visa: {
    name: 'visa',
    id: 'visa',
    logo: require('@/assets/images/payment/payment-methods/light/visa.png'),
    logoDark: require('@/assets/images/payment/payment-methods/dark/visa.png'),
  },
  master: {
    name: 'master',
    id: 'master',
    logo: require('@/assets/images/payment/payment-methods/light/master.png'),
    logoDark: require('@/assets/images/payment/payment-methods/dark/master.png'),
  },
  amex: {
    name: 'amex',
    id: 'amex',
    logo: require('@/assets/images/payment/payment-methods/light/amex.png'),
    logoDark: require('@/assets/images/payment/payment-methods/dark/amex.png'),
  },
  paypal: {
    name: 'paypal',
    id: 'paypal',
    logo: require('@/assets/images/payment/payment-methods/light/paypal.png'),
    logoDark: require('@/assets/images/payment/payment-methods/dark/paypal.png'),
  },
  knet: {
    name: 'knet',
    id: 'knet',
    logo: require('@/assets/images/payment/payment-methods/light/knet.png'),
    logoDark: require('@/assets/images/payment/payment-methods/dark/knet.png'),
  },
  benefit: {
    name: 'benefit',
    id: 'benefit',
    logo: require('@/assets/images/payment/payment-methods/light/benefit.png'),
    logoDark: require('@/assets/images/payment/payment-methods/dark/benefit.png'),
  },
  fawry: {
    name: 'fawry',
    id: 'fawry',
    logo: require('@/assets/images/payment/payment-methods/light/fawry.png'),
    logoDark: require('@/assets/images/payment/payment-methods/dark/fawry.png'),
  },
  applePay: {
    name: 'applePay',
    id: 'applePay',
    logo: require('@/assets/images/payment/payment-methods/light/apple-pay.jpg'),
    logoDark: require('@/assets/images/payment/payment-methods/dark/apple-pay.jpg'),
  },
  wiretransfer: {
    name: 'wiretransfer',
    id: 'wiretransfer',
    logo: require('@/assets/images/payment/payment-methods/light/wire-transfer.png'),
    logoDark: require('@/assets/images/payment/payment-methods/dark/wire-transfer.png'),
  },
  /* eslint-enable global-require */
}

export default paymentMethodsList
